import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=fb814c0e&lang=pug"
import script from "./Ui.vue?vue&type=script&lang=js"
export * from "./Ui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports